import React from "react";
import { innerJoin } from "ramda";
import Header from "components/order-shared/header";
import { FULFILLMENT } from "utils/enum";
import { OrderProfileContext } from "./context";
import { selectors } from "reducers";
import { useSelector } from "react-redux";
import { canEditOrder } from "utils/order-permissions";

const SendToFulfillment = () => {
  const { order, updateOrder } = React.useContext(OrderProfileContext);
  const userRole = useSelector(selectors.getUserRole);
  const acceptable_fulfillment = order.acceptable_fulfillment ?? [];

  if (order.order_status !== "Accepted") return null;
  if (!canEditOrder(userRole, order.order_status)) return null;

  return (
    <div className="send-to-fulfillment">
      {acceptable_fulfillment.length === 0 ? null : (
        <>
          <Header>Send to Fulfillment</Header>
          <div>
            {innerJoin(
              (f, value) => f.value === value,
              FULFILLMENT,
              acceptable_fulfillment ?? []
            ).map(({ text, value }) => (
              <button
                key={value}
                onClick={() => {
                  updateOrder({ fulfillment_type: value });
                }}
              >
                {text}
              </button>
            ))}
          </div>
        </>
      )}
    </div>
  );
};

export default SendToFulfillment;
